import { Loadable } from '@gdp/react-app/lib/helpers/loadable';

export const LoadableUserRoutes = Loadable(
  './UserRoutes',
  () => import(/* webpackChunkName: "User" */ './UserRoutes'),
  () => [(require as any).resolveWeak('./UserRoutes')]
);
